import { base } from './base';
import { AT } from './AT';
import { CZ } from './CZ';
import { SK } from './SK';
import { RO } from './RO';
import { HU } from './HU';
import { HR } from './HR';

export const ownFxTransferFeatureConfigMap = {
    base,
    AT,
    CZ,
    SK,
    RO,
    HU,
    HR,
};
